import ApiConstant from "./ApiContstant";
import DataService from "./DataService";

export interface GetTagsListRequest {
    LocationId?: number | null
}

export interface GetTagsListResponse {
    Tags: string[]
}

export interface GetEquipmentListRequest {
    LocationId?: number | null
}

export interface GetEquipmentListResponse {
    ResEquipments: Equipment[]
}

export interface Equipment {
  id: number;
  name: string;
  icon: string | null;
}

export interface GetAvailableResourceListRequest {
    Search?: string;
    Location?: {
      LocationId: number;
      Country: string;
      City: string;
      Site: string;
      Building: string;
      Floor: string;
      Zone: string;
    };
    Keywords?: string[];
    Equipment?: string[];
    Spacetype?: string[];
    Occupancy?: number;
    StartTime?: string; //"DD/MM/YYYY HH:mm"
    EndTime?: string; //"DD/MM/YYYY HH:mm"
    Timezone?: string; //"GMT Standard Time"
}

export interface GetAvailableResourceListResponse {
  SearchResultObjects: Resource[];
}

export interface Resource {
    Id: number;
    ResID: number;
    ResName: string;
    Status: number;
    TitleMandatory: boolean;
    RoomImage: string;
    Occupancy: number;
    Description: string;
    Keywords: string[];
    Equipment: ResourceEquipment[];
    Location: {
      LocationId: number;
      Country: string;
      City: string;
      Site: string;
      Building: string;
      Floor: string;
      Zone: string;
    };
    SpaceType: string;
    SpaceTypeIcon: string;
    MapID: number;
    SetupDuration: number;
    CleardownDuration: number;
    LastUsedOrLastCleaned: string;
    IsRecurringBookingEnabled: boolean;
    BookMandatorySpaceUsageAcceptanceText: string;
    CheckInMandatorySpaceUsageAcceptanceText: string;
}

export interface ResourceEquipment {
  ResourceId: number;
  EquipmentId: number;
  ImagePath: string;
  Name: string;
  FaultImagePath: string;
  Status: number;
}

class SearchService {
  async getSearchTagsList(
    payload: GetTagsListRequest
  ): Promise<GetTagsListResponse> {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.GetSearchTagsList,
      payload
    );

    return response?.data?.d ?? [];
  }

  async getSearchEquipmentList(
    payload: GetEquipmentListRequest
  ): Promise<GetEquipmentListResponse> {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.GetResourceEquipmentList,
      payload
    );

    return response?.data?.d ?? [];
  }

  async getAvailableResourceList(
    payload: GetAvailableResourceListRequest
  ): Promise<GetAvailableResourceListResponse> {
    const response = await DataService.postData(
      localStorage.getItem("tenantUrl") + ApiConstant.GetAvailableResourceList,
      payload
    );

    return response?.data?.d ?? [];
  }
}

export default new SearchService;
